import * as yup from 'yup';

import { requiredStringField } from '@blockpulse3/web-client/forms';

export const kycSchema = yup.object({
  identityDocumentFile: requiredStringField,
  identityDocumentSecondaryFile: requiredStringField,
});
